import PropTypes from 'prop-types';

const themeShape = PropTypes.object;

export { themeShape };
